export default "__VITE_ASSET__CjmjaK5C__"